import { colors, fonts } from '../theme';

const compareCols = [
  {
    label: 'What it costs — speed',
    title: 'Slow',
    items: [
      'Extra labour spent chasing evidence and validating it against requirements, standards, and regulations',
      'Delayed clearance at every gate',
    ],
  },
  {
    label: 'What it costs — accuracy',
    title: 'Error-prone & inconsistent',
    items: [
      'Rework and material wastage from missed defects',
      'Reviewer-to-reviewer inconsistency drives supplier disputes and customer escalations',
    ],
  },
  {
    label: 'What it costs — downstream',
    title: 'Not machine-verifiable',
    items: [
      'Every buyer rebuilds conformance from zero',
      "A factory's track record stays invisible outside the relationship it was built in",
    ],
  },
];

const cardStyle = { background: colors.bg, border: `1px solid ${colors.border}`, borderRadius: 14, padding: '28px 26px' };

const GroundReality = () => (
  <section id="product" style={{ padding: 'clamp(56px, 8vw, 96px) clamp(20px, 5vw, 48px)', background: colors.bgAlt }}>
    <div style={{ maxWidth: 1080, margin: '0 auto' }}>
      <div style={{ maxWidth: 760, marginBottom: 48 }}>
        <p style={{ color: colors.teal, fontSize: 12.5, fontFamily: fonts.mono, letterSpacing: '0.14em', textTransform: 'uppercase', fontWeight: 600, marginBottom: 16 }}>Ground reality</p>
        <h2 style={{ fontSize: 'clamp(26px,3.4vw,38px)', fontFamily: fonts.display, lineHeight: 1.3, color: colors.navy, marginBottom: 14 }}>
          How material conformance is assessed today
        </h2>
        <p style={{ color: colors.slateDark, fontSize: 16.5, lineHeight: 1.65, maxWidth: 640 }}>
          A quality engineer manually cross-checks supplier documents, production data, and quality records against requirements — per shipment, per buyer. Every system in the plant creates a record. None of them create proof.
        </p>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit,minmax(280px,1fr))', gap: 20 }}>
        {compareCols.map((c, i) => (
          <div key={i} style={cardStyle}>
            <div style={{ fontFamily: fonts.mono, fontSize: 11, textTransform: 'uppercase', letterSpacing: '0.1em', color: colors.slate, marginBottom: 14 }}>{c.label}</div>
            <div style={{ color: colors.navy, fontSize: 19, fontWeight: 700, marginBottom: 14 }}>{c.title}</div>
            <ul style={{ listStyle: 'none', display: 'flex', flexDirection: 'column', gap: 10 }}>
              {c.items.map((item, j) => (
                <li key={j} style={{ fontSize: 14.5, color: colors.slate, paddingLeft: 16, position: 'relative', lineHeight: 1.6 }}>
                  <span style={{ position: 'absolute', left: 0, color: colors.slate }}>–</span>{item}
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>

      <div style={{ marginTop: 36, background: colors.navy, color: '#fff', borderRadius: 14, padding: '22px 28px', fontSize: 14.5, lineHeight: 1.6 }}>
        Conformance leakage costs factories an estimated <b style={{ color: colors.teal }}>1–1.5% of revenue</b> — because an unverifiable evaluation forces every downstream buyer to re-assess from scratch.
      </div>
    </div>
  </section>
);

export default GroundReality;
